import { useOptimisticallyUpdateQueriesWithPredicate, upsertItemInArrayById } from '@fabric-app/queries/utilities';
import { useQueryClient } from '@tanstack/react-query';
import { shareTokensByResourceId } from './shareTokensPredicates.js';

const useQueryCacheShareTokenHelpers = () => {
  const queryClient = useQueryClient();
  const optimisticallyUpdateQueries = useOptimisticallyUpdateQueriesWithPredicate();
  return {
    updateTokenRole: (variables) => {
      queryClient.cancelQueries({
        predicate: (q) => {
          return shareTokensByResourceId(q, variables.resourceId);
        }
      });
      const updateItem = {
        id: variables.shareTokenId,
        role: variables.role
      };
      const optimisticallyUpdatedQueries = optimisticallyUpdateQueries((q) => shareTokensByResourceId(q, variables.resourceId), (data) => upsertItemInArrayById(data || [], updateItem, {
        createIfNotFound: false
      }));
      return {
        resetCacheToPreOptimisticState: () => {
          optimisticallyUpdatedQueries.resetQueriesData();
        },
        invalidateQueries: () => {
          optimisticallyUpdatedQueries.invalidateQueries();
        }
      };
    },
    deleteToken: (variables) => {
      queryClient.cancelQueries({
        predicate: (q) => {
          return shareTokensByResourceId(q, variables.resourceId);
        }
      });
      const optimisticallyUpdatedQueries = optimisticallyUpdateQueries((q) => shareTokensByResourceId(q, variables.resourceId), (data) => data?.filter((item) => item.id !== variables.shareTokenId) || data);
      return {
        resetCacheToPreOptimisticState: () => {
          optimisticallyUpdatedQueries.resetQueriesData();
        },
        invalidateQueries: () => {
          optimisticallyUpdatedQueries.invalidateQueries();
        }
      };
    }
  };
};

export { useQueryCacheShareTokenHelpers };
//# sourceMappingURL=useQueryCacheShareTokenHelpers.js.map
